import React from 'react';
import { Card, Row, Col } from 'antd';
import { DatabaseOutlined, AppstoreOutlined, TeamOutlined, ArrowLeftOutlined, ExperimentOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const ADMIN_TILES = [
    {
        key: 'redis-management',
        title: 'Redis Management',
        description: 'View and manage Redis cache keys, monitor memory usage',
        icon: <DatabaseOutlined className="text-xl text-purpleFont" />,
        pathSuffix: '/admin/cache-management',
    },
    {
        key: 'features',
        title: 'Features',
        description: 'Configure and manage platform features and modules',
        icon: <AppstoreOutlined className="text-xl text-purpleFont" />,
    },
    {
        key: 'user-management',
        title: 'User Management',
        description: 'Manage users, roles, and access permissions',
        icon: <TeamOutlined className="text-xl text-purpleFont" />,
    },
];

const FEATURE_TILES = [
    {
        key: 'simulator-validation',
        title: 'Pricing Simulator',
        description: 'Run KPI simulations, validate data, and bulk upload',
        icon: <ExperimentOutlined className="text-xl text-purpleFont" />,
        pathSuffix: '/admin/simulator-validation',
    },
];

const AdminSettings = () => {
    const navigate = useNavigate();
    const [showFeatures, setShowFeatures] = React.useState(false);

    const onAdminCardClick = (tile: (typeof ADMIN_TILES)[number]) => {
        if (tile.key === 'features') {
            setShowFeatures(true);
            return;
        }

        if (tile.pathSuffix) {
            navigate(tile.pathSuffix);
        }
    };

    const currentTiles = showFeatures ? FEATURE_TILES : ADMIN_TILES;

    return (
        <div id="admin-settings-page" className="p-6 bg-white min-h-full">
            {showFeatures && (
                <button
                    type="button"
                    className="mb-4 text-sm text-greyFont bg-transparent border-0 p-0 cursor-pointer flex items-center gap-2"
                    onClick={() => setShowFeatures(false)}
                >
                    <ArrowLeftOutlined />
                    Back
                </button>
            )}
            <h1 className="text-xl font-semibold text-fontColor m-0 mb-2">{showFeatures ? 'Features' : 'Admin Dashboard'}</h1>
            <p className="text-sm text-greyFont m-0 mb-6">
                {showFeatures
                    ? 'Browse and manage available platform features'
                    : 'Manage system settings, features, and users'}
            </p>
            <Row gutter={[16, 16]}>
                {currentTiles.map((tile) => (
                    <Col key={tile.key} xs={24} sm={12} md={8}>
                        <Card
                            hoverable
                            className="!rounded-lg h-full"
                            onClick={() => {
                                if (showFeatures) {
                                    if (tile.pathSuffix) navigate(tile.pathSuffix);
                                    return;
                                }
                                onAdminCardClick(tile);
                            }}
                        >
                            <div className="flex flex-col gap-2">
                                <div className="flex items-center gap-3">
                                    <div className="w-11 h-11 rounded-lg bg-bgBackground flex items-center justify-center flex-shrink-0">
                                        {tile.icon}
                                    </div>
                                    <span className="font-semibold text-fontColor">{tile.title}</span>
                                </div>
                                <p className="text-sm text-greyFont m-0">{tile.description}</p>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default AdminSettings;
